import { component } from 'picoapp'

export default component((node, ctx) => {

    const successMessage = node.querySelector('.form--success')

    if (successMessage) {
        node.scrollIntoView();
    }

})
